/* RESPONSIBLE TEAM: team-proactive-support */
import { belongsTo } from '@ember-data/model';
import RulesetLink from '../ruleset-link';
import type Nudge from 'embercom/models/messenger/nudge';
import { objectTypes } from 'embercom/models/data/matching-system/matching-constants';

export default class extends RulesetLink {
  @belongsTo('messenger/nudge', { async: false }) declare object: Nudge;

  get objectType() {
    return objectTypes.nudge;
  }
}
